import { render, staticRenderFns } from "./atlas_introduction.vue?vue&type=template&id=f9d214d4&scoped=true&"
import script from "./atlas_introduction.vue?vue&type=script&lang=js&"
export * from "./atlas_introduction.vue?vue&type=script&lang=js&"
import style0 from "./atlas_introduction.vue?vue&type=style&index=0&id=f9d214d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d214d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f9d214d4', component.options)
    } else {
      api.reload('f9d214d4', component.options)
    }
    module.hot.accept("./atlas_introduction.vue?vue&type=template&id=f9d214d4&scoped=true&", function () {
      api.rerender('f9d214d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/atlas/_tool/atlas_introduction.vue"
export default component.exports